import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class MetadataService {
	constructor(
		private db: SpaqFireDb,
		private auth: AngularFireAuth
	) {}

	hydrate(): Observable<any> {
		return this.auth.user.pipe(switchMap(u => this.db.userMetadataSnapshot$(u.uid).pipe(map(x => x.payload.val()))));
	}
}
